import React, {forwardRef} from 'react'
import PropTypes from 'prop-types'
import {FormCheckbox} from '../../01-Atoms/FormCheckbox/FormCheckbox'
import {Section} from '../../02-Molecules/Section/Section'

import './SectionGiftAid.scss'

/**
 * SectionGiftAid component.
 */
export const SectionGiftAid = forwardRef(({ collapsed, giftaidRate, heading, headingLarge, sectionId, values, staticText, tracking, trackEvent, donationFeeRate = 1, ...props }, ref) => {

  /**
   * Handle any form changes.
   *
   * @param {string} name
   *   The value name
   *
   * @param {boolean} isChecked
   *   A boolean indicating if the checkbox is checked
   */
  const handlerInputChange = (name, isChecked) => {
    props.onInputChange(name, isChecked ? 'Y' : '')

    if (tracking && trackEvent) {
      trackEvent(tracking.id, `Gift aid toggled`)
    }
  }

  /**
   * Replace tokens in the given text.
   *
   * @param {string} text
   *   The text on which to perform the token replacement.
   * @returns {string}
   *   The newly generated string.
   */
  const replaceTokens = text => {
    const giftAidAmount = (parseFloat(values.payment_amount) * giftaidRate).toFixed(2).replace('.00', '')
    return text.replace('{DONATION_AMOUNT}', parseFloat(values.payment_amount).toFixed(2).replace('.00', '')).replace('{GIFTAID_AMOUNT}', giftAidAmount)
  }

  return (
    <React.Fragment>
      {values.payment_amount ?
        <Section sectionClass={'callout'} tracking={tracking} trackEvent={trackEvent} collapsed={collapsed} heading={heading} headingLarge={headingLarge}
        sectionId={sectionId} textAfter={staticText.giftaid.text_after}>
            <span className="o-section-gift-aid__logo">Gift aid it</span>

            <div className="o-section-gift-aid__text" dangerouslySetInnerHTML={{__html: replaceTokens(staticText.giftaid.text_before)}} />

            <div className="o-section-gift-aid__input">
              <FormCheckbox
                checked={values.giftaid === 'Y'}
                label={staticText.giftaid.option_label}
                name={'giftaid'}
                onInputChange={handlerInputChange}  />
            </div>
        </Section> : null}
    </React.Fragment>
  )
})

/**
 * SectionGiftAid PropTypes.
 */
SectionGiftAid.propTypes = {
  collapsed    : PropTypes.bool,
  heading      : PropTypes.string,
  headingLarge : PropTypes.bool,
  sectionId    : PropTypes.string,
  onInputChange: PropTypes.func,
  giftaidRate  :PropTypes.number,
  staticText   : PropTypes.shape({
    giftaid: PropTypes.shape({
      text_after  : PropTypes.string,
      text_before : PropTypes.string,
      option_label: PropTypes.string,
    })
  }),
  tracking: PropTypes.shape({
    id  : PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    name: PropTypes.string,
    type: PropTypes.oneOf(['entry', 'exit', 'entry_exit'])
  }),
  trackEvent: PropTypes.func,
  values    : PropTypes.shape({
    giftaid       : PropTypes.string,
    payment_amount: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number
    ]),
  })
}
